import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

Vue.use(Vuex);

axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    console.log(error);
    test.commit('alertError', error.response.data.message);
});

export default async function request(payload) {
    const { method, url } = payload;
    let options = {
        method,
        url,
        baseURL: process.env.VUE_APP_API_BASE_URL,
        cancelToken: source.token
    };
    if (payload.data) {
        options.data = payload.data;
    }
    if (payload.params) {
        options.params = payload.params;
    }
    if (payload.auth) {
        options.headers = {
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
    }
    return axios(options);
}